// extracted by mini-css-extract-plugin
export var mainScreenTextLeft = "textLeft-module--mainScreenTextLeft--WHCHG";